import numeral from 'numeral';

let currentLanguageCode = null;

export default class Core {
  
  static currentLanguage() {
    if (currentLanguageCode == null && (localStorage.getItem('language') == 'en_GB' || localStorage.getItem('language') == 'pt_PT')) {
      currentLanguageCode = localStorage.getItem('language');
    }
    currentLanguageCode = currentLanguageCode || 'en_GB';
    if (currentLanguageCode == 'pt_PT') {
      numeral.locale('pt');
    } else {
      numeral.locale('en');
    }
    return currentLanguageCode;
  }

  static changeLanguage(code) {
    currentLanguageCode = code;
    localStorage.setItem('language', code);
  }
  
  static info(data) {
    if (data) {
      sessionStorage.setItem('info', JSON.stringify(data));
    } else if (data === null) {
      sessionStorage.removeItem('info');
    } else {
      if (sessionStorage.getItem('info')) {
        return JSON.parse(sessionStorage.getItem('info'));
      }
    }
    return null;
  }

  static numeral(value) {
    return numeral(value).format('0.00');
  }
  
}
